import { PresetSchema } from "@redotech/redo-model/outbound-labels/presets";
import * as z from "zod/v4";

export const getPresets = {
  name: "getPresets" as const,
  input: z.object({}),
  output: z.object({ presets: z.array(PresetSchema) }),
};
